import React from "react";
import { YahooContent } from "../yahoo/YahooContent";
import { RollerAdsContent } from "../rollerads/RollerAdsContent";
import { useLanderConfig } from "../commons/ConfigContext";
import { FeedType } from "../types/LanderConfig";

export function AdContent() {
  const { landerConfig } = useLanderConfig();

  if (landerConfig.lander?.feedID === FeedType.ROLLER_ADS) {
    return <RollerAdsContent />;
  }

  return <YahooContent />;
}
